import { ReactElement } from "react";
import { ApplicationCreate } from "../../components/ApplicationCreate/ApplicationCreate";

import classes from "./PageApplicationCreate.module.css";

/**
 * Компонент страницы создания заявки
 */
export function PageApplicationCreate(): ReactElement {
  return (
    <div className={classes.applicationCreationPage}>
      <div className={classes.applicationCreationPage__header}>
        <h1 className={classes.applicationCreationPage__heading}>
          Создать заявку
        </h1>
      </div>

      <ApplicationCreate />
    </div>
  );
}
